import {StripeClientOptions} from "../add-new";
declare let StripeCheckout:any;
RedNaoEventManager.Subscribe('GetClientExtension',function(data){

    data.Extensions.push(new SFStripeExtension(data));
});

declare let RedNaoEventManager:any;

class SFStripeExtension {
    public StripeOptions:StripeClientOptions;
    public Generator:any;
    constructor(data)
    {
        this.Generator=data.Generator;
        if(typeof data.Generator.client_form_options.Extensions.sf_stripe!=='undefined')
        {
            this.StripeOptions=data.Generator.client_form_options.Extensions.sf_stripe;

        }else
            this.StripeOptions={
                Currency:'',
                Condition:'',
                Amount:'',
                ItemName:'',
                Enabled:'n',
                PublicKey:'',
                Email:''
            }

    }

    public get IsEnabled(){
        return this.StripeOptions.Enabled=='y';
    }


    public BeforeSendingToSmartFormsForm(generator,formValues){
        if(this.IsEnabled) {
            return new Promise((resolve)=>{
                if(typeof this.StripeOptions.Condition!='undefined')
                {
                    if(typeof this.StripeOptions.Condition.DonationSettings!='undefined'&& this.StripeOptions.Condition.DonationSettings.RequestPayment=='condition')
                    {
                        var calculation = RedNaoEventManager.Publish('CalculateCondition', {
                            Condition: this.StripeOptions.Condition.DonationSettings.ConditionSettings,
                            Values: generator.GetCurrentData()
                        });

                        calculation.then( (result) =>{
                            if (result)
                                this.InternalSentToSmartForms(resolve,generator,formValues);
                            else
                                resolve(true);
                        });
                    }else{
                        this.InternalSentToSmartForms(resolve,generator,formValues);
                    }
                }

            })
        }
    }

    public InternalSentToSmartForms(resolve,generator,formValues)
    {
        let amountResult=0;
        let tokenWasGenerated:boolean=false;
        console.log(formValues);





        var formula=new RedNaoFormula(null,this.StripeOptions.Amount.Formulas.StripeFormula);
        var amount=formula.GetValueFromFormula(RedNaoFormulaManagerVar.Data);
        amount.then(result=>{

            amountResult=result.toString()*100;
            if(isNaN(amountResult))
            {
                alert('Invalid payment amount');
                resolve(false);
                return;
            }


            let emailField=this.Generator.FormElements.find(x=>x.Options.Id==this.StripeOptions.Email);
            let email='';
            if(emailField!=null)
                email=emailField.GetValueString().value;

            formValues._stripe={
                data:{
                    amount:amountResult,
                    currency:this.StripeOptions.Currency,
                    name:this.StripeOptions.ItemName
                }
            };

            resolve(true);
        });
    }


}

RedNaoEventManager.Subscribe('SubmitAction',e=>{

    if(e.Action.Action=='Stripe')
    {
        debugger;
        let stripe=new Stripe(e.Generator.client_form_options.Extensions.sf_stripe.PublicKey);
        stripe.redirectToCheckout({sessionId:e.Action.Value});

    }
})

declare let RedNaoFormula;
declare let Stripe:any;
declare let RedNaoFormulaManagerVar:any;